import { useMutation, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { GET_USER_QUERY } from "../GraphQl/query";
import { PageWrapper } from "../PageWrapper";
import GenericListContainer from "../GenericList/GenericListContainer";
import { duplicateResponse } from "../Helpers/functions";
import { useState } from "react";
import { getDetailsColumn, getRemoveColumn } from "../genericFunctions";
import { ManageUserModal } from "../Modals/ManageUserModal/ManageUserModal";
import { AddButton } from "../CommonComponents";
import { CREATE_USER, UPDATE_USER } from "../GraphQl/mutation";

export const UsersListContainer = () => {
  const { instituteCode } = useParams();
  const [userValues, setUserValues] = useState();
  const [modalState, setModalState] = useState(false);

  const { t } = useTranslation();

  const TableHeader = (
    <AddButton
      action={() =>
        setUserValues({
          email: "",
          name: "",
          surname: "",
        })
      }
      toggleModalState={setModalState}
    />
  );

  const primaryColumns = [getDetailsColumn(setUserValues, setModalState)];
  const additionalColumns = [getRemoveColumn({ isDisabled: true })];

  const { loading, data, error } = useQuery(GET_USER_QUERY, {
    variables: { instituteCode },
  });
  const isUpdate = userValues?.id;
  const usersList = duplicateResponse(data?.result);

  const getMutation = () => {
    return isUpdate ? UPDATE_USER : CREATE_USER;
  };

  const [saveUser] = useMutation(getMutation(), {
    onCompleted(data) {
      setModalState(false);
    },
  });

  const handleSubmit = (user) => {
    const { id, email, name, surname } = user || {};

    saveUser({
      variables: {
        userId: id,
        data: {
          email: email || "",
          username: email || "",
          name: name || "",
          surname: surname || "",
          instituteCode: instituteCode,
        },
      },
      update: (proxy, { data: { result } }) => {
        const cacheData = proxy.readQuery({
          query: GET_USER_QUERY,
          variables: { instituteCode },
        });
        if (cacheData) {
          proxy.writeQuery({
            query: GET_USER_QUERY,
            variables: { instituteCode },
            data: {
              ...cacheData,
              result: isUpdate
                ? cacheData.result
                : [...cacheData.result, result],
            },
          });
        }
      },
    });
  };

  return (
    <PageWrapper loading={loading} error={error}>
      <GenericListContainer
        list={usersList}
        structureName="User"
        primaryColumns={primaryColumns}
        additionalColumns={additionalColumns}
        TableHeader={TableHeader}
      />
      <ManageUserModal
        modalState={modalState}
        toggleModal={setModalState}
        defaultValues={userValues}
        translate={t}
        handleSubmit={handleSubmit}
      />
    </PageWrapper>
  );
};
